module.exports = __webpack_public_path__ + "static/media/litecoin.ff3046d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/litecoin.svg
// module id = 853
// module chunks = 7